/**
 * Ключи массива `userSession.experiments` (совпадают с элементами MongoDB users.experiments).
 */
/** На странице шаблона скрываем техподдержку TG/MAX; общение — через ИИ-чат шаблона. */
export const EXPERIMENT_TEMPLATE_SUPPORT_AI_CHAT = "template_support_ai_chat" as const

/** Онбординг H69: визард «свой .docx → ИИ» вместо Welcome-плашки. */
export const EXPERIMENT_ONBOARDING_OWN_TEMPLATE_AI = "onboarding_own_template_ai" as const

export function isOnboardingOwnTemplateAi(experiments?: unknown): boolean {
    return Array.isArray(experiments) && experiments.includes(EXPERIMENT_ONBOARDING_OWN_TEMPLATE_AI)
}

export function prepaidAiTemplateConfigurationCount(
    userSession?: { ai_template_configuration_prepaid_count?: number } | null,
): number {
    const n = userSession?.ai_template_configuration_prepaid_count
    return typeof n === "number" && n > 0 ? n : 0
}
